






























import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {FaturamentoFilterCollection} from '@/model/filter/FaturamentoFilterCollection'
import {FaturamentoFilterSchema} from '@/schema/filter/FaturamentoFilterSchema'

@Component
export default class FaturamentoFilter extends Vue {
  @Prop({type: Object, required: true}) filter!: FaturamentoFilterCollection

  schema = new FaturamentoFilterSchema()

  created() {
    this.applyFilter()
  }

  async applyFilter() {
    this.filter.resource = this.schema

    const promises: Array<Promise<any>> = [this.filter.yearOptions()]

    await this.$await.run('adapQuery', () => Promise.all(promises))
  }

  async submitEvent() {
    this.$emit('submit')
    this.filter.setCurrentPage(0)
    await this.$await.run('adapQuery', () => this.filter.queryAsPage())
  }
}
